import { api } from '@weareconceptstudio/core';

export function formatAmd(value) {
	return `${Number(value || 0).toLocaleString()} AMD`;
}

export function getCartSubtotal() {
	try {
		const { useCartStore } = require('@weareconceptstudio/cart');
		const state = useCartStore.getState();

		return Number(state?.subtotal ?? 0) || 0;
	} catch {
		return 0;
	}
}

export function formatZoneName(zone, lang = 'hy') {
	if (!zone) return '';

	if (typeof zone === 'string') {
		return zone;
	}

	if (typeof zone === 'object') {
		return zone[lang] || zone.hy || zone.en || zone.ru || Object.values(zone).find((value) => typeof value === 'string') || '';
	}

	return '';
}

export async function resolveDeliveryPricing({
	lat,
	lon,
	subtotal = getCartSubtotal(),
	lang = 'hy',
}) {
	const response = await api.post(
		'delivery/resolve',
		{
			lat,
			lng: lon,
			subtotal,
			lang,
		},
		{
			headers: {
				'Content-Language': lang,
			},
		}
	);

	const payload = response?.data ?? response;

	if (!payload || typeof payload !== 'object') {
		return payload;
	}

	return {
		...payload,
		zone: formatZoneName(payload.zone, lang),
	};
}
